import { Breadcrumb, Button, Card, Form, Table } from "components/ui/BootstrapCompat";

type Props = {};

export default function LogPage({}: Props) {
  return (
    <div className="min-w-0">
      <Breadcrumb>
        <Breadcrumb.Item active>ເຄື່ອງມືພື້ນຖານ</Breadcrumb.Item>
        <Breadcrumb.Item active>ປະຫວັດລະບົບ</Breadcrumb.Item>
      </Breadcrumb>
      <div className="mb-2 flex flex-wrap gap-2 rounded bg-white p-2">
        <Form.Control
          type="text"
          placeholder="Filter"
          className="min-w-0 flex-[1_1_100%] border border-primary md:flex-none md:w-[200px]"
        />
        <Button variant="primary" className="flex flex-1 items-center sm:flex-none">
          <span className="material-icons">Filter</span>
        </Button>
      </div>
      <div>
        <Card border="primary">
          <Card.Header className="p-1">ລາຍການ</Card.Header>
          <Table striped bordered hover size="sm" className="min-w-[600px]">
            <thead>
              <tr>
                <th className="py-2 px-3 text-left border-b w-[60px]">No.</th>
                <th className="py-2 px-3 text-left border-b">Logs</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-2 px-3 border-b">1</td>
                <td className="py-2 px-3 border-b">
                  <div>
                    <code className="bg-gray-100 p-1 rounded text-[12px] text-primary">
                      INFO 2024-06-24 10:00:00 - User admin logged in from IP
                      192.168.1.1
                    </code>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </Card>
      </div>
    </div>
  );
}
